import { render, staticRenderFns } from "./jobXq.vue?vue&type=template&id=c9715a64&scoped=true"
import script from "./jobXq.vue?vue&type=script&lang=js"
export * from "./jobXq.vue?vue&type=script&lang=js"
import style0 from "./jobXq.vue?vue&type=style&index=0&id=c9715a64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9715a64",
  null
  
)

export default component.exports